import { apiInstance } from "@/utils/ApiUtil";
const baseURL = "/admin/support";

const getTickets = async (data) => {
    try {
        const response = await apiInstance.get(baseURL + "/ticket/all", {
            params: {
                search: data.search,
                status: data.status,
                priority: data.priority,
                type: data.type,
                page: data.page,
                limit: data.limit,
                include_user: data.include_user
            }
        });

        if (!response?.data?.success) return false;
        return response.data;
    } catch (error) {
        console.error("Error fetching tickets:", error);
        return false;
    }
};

const replyTicket = async (data) => {
    try {
        const response = await apiInstance.post(baseURL + `/ticket/${data.id}/reply`, data);
        return response.data.success ? response.data : false;

    } catch (error) {
        return false;
    }
};

const updateStatus = async (ticketId, status) => {
    try {
        const response = await apiInstance.put(baseURL + `/ticket/${ticketId}/status`, { status });
        return response.data.success ? response.data : false;
    } catch (error) {
        return false;
    }
};

const updateTicketPriority = async (ticketId, priority) => {
    try {
        const response = await apiInstance.put(baseURL + `/ticket/${ticketId}/priority`, { priority });

        if (!response?.data?.success) return false;

        return response.data;
    } catch (error) {
        console.error("Error updating ticket priority:", error);
        return false;
    }
};

const deleteTicket = async (ticketId) => {
    try {
        const response = await apiInstance.delete(baseURL + `/ticket/${ticketId}`);
        return response.data.success ? response.data : false;
    } catch (error) {
        return false;
    }
};

const AdminSupportService = {
    replyTicket,
    updateStatus,
    getTickets,
    updateTicketPriority,
    deleteTicket
}

export default AdminSupportService;